<template>
    <div id='approval_modal' class="modal">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Approval Required</p>
            </header>
            <section class="modal-card-body">
                <div>Approval is required BEFORE pulling stock from this warehouse</div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" @click="doClose()">
                    I talked with Chris or Victoria
                </button>
                <button class="button is-danger" @click="doCancel()">
                    Cancel
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "ApprovalModal",
    methods: {
        doCancel() {
            this.$emit('doCancel')
        },
        doClose() {
            this.$emit('doClose')
        },
    }
};

</script>
